import type { Router } from "vue-router";
import { IS_MULTIPLAYER_TEMPORARILY_DISABLED } from "@/assets/js/appConfig";
import { useDefaultStore } from "@/store";
import { routes } from "vue-router/auto-routes";

export const routerOptions = {
	routes,
};

const IS_ADMIN_PANEL_TEMPORARILY_BLOCKED = true;

function isCategoryRootPath(path: string) {
	return ["/movies", "/music", "/people"].includes(path.replace(/\/$/, ""));
}

function isSinglePlayerGamePath(path: string) {
	return /^\/(movies|music|people)\/(classic-game|beat-the-clock)\/?$/.test(path);
}

export function setupRouter(router: Router) {
	router.beforeEach(async (to, from) => {
		if (
			IS_ADMIN_PANEL_TEMPORARILY_BLOCKED &&
			to.path.startsWith("/admin-panel")
		) {
			return "/";
		}

		if (IS_MULTIPLAYER_TEMPORARILY_DISABLED) {
			if (to.path.startsWith("/movies/weakest-link/")) {
				return "/movies";
			}

			if (to.path.startsWith("/music/weakest-link/")) {
				return "/music";
			}

			if (to.path.startsWith("/people/weakest-link/")) {
				return "/people";
			}
		}

		if (isCategoryRootPath(to.path) && isSinglePlayerGamePath(from.path)) {
			await useDefaultStore().getUser();
		}

		return true;
	});
}
